import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const fulfillmentMethodOptimizationPLPSelector = createSelector(
    testTargetOffersSelector,
    offers => offers.showFulfillmentMethodOptimizationPLP || Empty.Object
);

export { fulfillmentMethodOptimizationPLPSelector };
